export default __webpack_public_path__ + "static/media/logo-neuf-colored.b16e4d3a.svg";